<template>
	<div id="leistungen" class='page'>
		<div class="leistung-container">


		<h2 data-aos="fade-in" :data-aos-duration=1000>
			 {{content.leistung_headline}}
		</h2>
		<div class="leistungen-col" v-for='(col, index) in content.leistung_column'  v-bind:key='col.caption'>
            <div class="abracket"data-aos="fade-in" :data-aos-duration=(index+1)*400></div>
            <div class="number" data-aos="fade-in" :data-aos-duration=(index+1)*500>
            	{{col.caption}}
            </div>
            <h3 data-aos="fade-up" :data-aos-duration=(index+1)*500>
            	{{col.headline}}
            </h3>
            <div class='line' data-aos="fade-up" :data-aos-duration="(index+1)*600"></div>

			<p v-if='!send' class='subline' data-aos="fade-up" :data-aos-duration="(index+1)*700">
				{{col.text[0].text}}

			</p>
		</div>

		</div>

</div>
</template>

<script>
	// import Client from '@/components/Client.vue'
	// import db from '@/components/firebaseinit'
	// import firebase from 'firebase'
	// const users = db.collection('users')

	export default {
		name: 'leistungen',
		components: {

		},
		props: {
			content: Object,
		    langsufix: String,
		    sidenav: Array,
		    isAdmin: Boolean,
		},
		data () {
			return {
				vorname: '',
				name: '',
				text: '',
				email: '',
				phone: '',
				privacy: false,
				required: false,
				send: false,
				p: {}

			}
		},
		// firestore: {
		// 	users: db.collection('clients').orderBy('createAt','desc')
		// },
		created () {
			// this.getContent();
			this.send = false;
		},
		methods: {



		}
	}
</script>

<style lang="less" scoped>
@import '../less/variables.less';

.leistung-container {
		margin-left: auto;
	    margin-right: auto;
	    width: 80%;


}

#leistungen {
	background-color: #FBFBFB;
	padding-top: 20px;
	// padding-bottom: 180px;
	position: relative;
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	// background-image: url('/images/bg_leistungen.jpg');
	background: rgb(99,94,93);
	background: -moz-linear-gradient(90deg, rgba(99,94,93,1) 0%, rgba(69,69,69,1) 100%);
	background: -webkit-linear-gradient(90deg, rgba(99,94,93,1) 0%, rgba(69,69,69,1) 100%);
	background: linear-gradient(90deg, rgba(99,94,93,1) 0%, rgba(69,69,69,1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#635e5d",endColorstr="#454545",GradientType=1);
	text-align: left;
	min-height: 800px;
	margin-left: auto;
    margin-right: auto;
    // padding: 20% 0px;

}

h2 {
	.fmb(40px);
    position: relative;
	color: white;
	text-transform: uppercase;
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: green;
    margin-bottom: 0px;



}

.leistungen-col {
	// display: inline-block;
    position: relative;
	vertical-align: top;
	text-align: left;
	width: 25%;
    // column-count: 2;
    // margin-left: auto;
    // margin-right: auto;
    padding: 50px 0px;
    display: inline-block;
    margin-right: 8%;
    .abracket {
        position: absolute;
        width: 33px;
        height: 37px;

        // background-color: yellow;
        // right: -100px;
        // margin-top: -40px;
        margin-left: -25px;
        margin-top: -25px;

        background-image: url('/images/tl-bracket-leistung.svg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center right;
    }
    .number {
    	.fmb(12px);
    	margin-bottom: 20px;
    }
    .line {
    	width: 100%;
    	height: 3px;
    	background-color: white;
    	margin-bottom: 25px;
    	margin-top: 25px;
    }
    h3 {
    	.fmb(20px);
    	line-height: 24px;
    }
    p {
        position: relative;
                // min-height: 200px;
                // background-color: red;
                .fm(15px);
                vertical-align: top;
                margin-top: 0px;
                width: 100%;
                margin-top: 0px;
                color: white;
    }
	@media (max-width: @mobile_width) {
		display: inherit;
		width: 98%;


	}

	// &.right {
	// 	margin-left: 40px;
	// }



	// p {
	// 	.fm(12px);
	// 	color: rgba(0,0,0,0.6);
	// 	width: 50%;
	// 	min-width: 250px;
	// }
		// @media (max-width: @mobile_width) {
	 //        .fmb(46px);
	 //        line-height: 46px;
	 //        display: inherit;
	 //        width: 100%;
	 //        // padding-bottom: 100px;

	 //        p {
	 //        	width: 100%;

	 //        }
	 //    }
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.page-content {
	// top: -100px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

#login {
	// margin-top: 300px;
}
#input-set {

	.inputs {
		position: relative;
		margin-top: 30px;
	}
	.thanks {
		h2 {
			.fmb(20px);
		}

	}
	#checkboxs {
		display: inline-block;
		width: 100px;
		background-color: red;
	}
	a {
		color: @g1;
	}
	label {
		vertical-align: top;
		// background-color: green;
		height: 150px;
		color: @g1;
		clear: both;
		.fm(14px);
		margin-left: 5px;
		&.required {
			color: red;
		}

	}
	input[type="checkbox"]
	{
	    vertical-align:middle;
	    float: left;
	    .fm(14px);

	    border-color: red;
	    border: solid;
	    background-color: red;
	}


	input[type="text"], input[type="tel"], input[type="email"] {
		border: none;
		outline: none;
		text-align: left;
		border-bottom: solid;
		border-color: @c2;
		border-width: 1px;
		padding: 0px 0px;

		height: 50px;
		width: 100%;
		position: relative;
		.fm(14px);
		margin-bottom: 15px;
		color: @c2;
		background-color: transparent;

		&.required {
			border-color: red;
		}
	}
	textarea {
		border: none;
		outline: none;
		text-align: left;
		border: solid;
		border-color: @c2;
		border-width: 1px;
		padding: 10px 10px;
		height: 100px;
		width: 95%;
		position: relative;
		.fm(14px);
		margin-bottom: 15px;
		color: @c2;
		background-color: transparent;
		&.required {
			border-color: red;
		}
	}
	::placeholder {
		color: @c2;
		.fm(14px);
		text-transform: uppercase;
	}
	#add-button {
		// .br(2px);
		.fmb(12px);
		line-height: 40px;
		color: @c2;
		height: 40px;
		position: relative;
		text-align: left;
		left: 0px;
		// float: left;
		cursor: pointer;
		margin-top: 10px;
		background-color: @c3;
		display: table;
		text-transform: uppercase;
		padding-left: 20px;
		padding-right: 20px;
		border: solid;
		margin-top: 20px;
		// .login-icon {
		// 	position: absolute;
		// 	width: 50px;
		// 	height: 50px;
		// 	margin-left: 20px;
		// 	display: inline-block;
		// 	// background-image: url('/images/arrow-right.svg');
		// 	background-position: center center;
		// 	background-size: 60% auto;
		// 	background-repeat: no-repeat;
		// }
		&:hover {
			background-color: rgba(0,0,0,0.1);
		}
	}
}
</style>
